var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// packages/apps/patterns/react-appkit/src/telemetry/listeners.ts
import * as Telemetry2 from "@dxos/telemetry";

// packages/apps/patterns/react-appkit/src/telemetry/telemetry.ts
import * as localForage from "localforage";
import { log } from "@dxos/log";
import * as Sentry from "@dxos/sentry";
import * as Telemetry from "@dxos/telemetry";
import { humanize } from "@dxos/util";
var BASE_TELEMETRY_PROPERTIES = {};
var _a;
if ((_a = navigator.storage) == null ? void 0 : _a.estimate) {
  setInterval(async () => {
    try {
      const storageEstimate = await navigator.storage.estimate();
      BASE_TELEMETRY_PROPERTIES.storageUsage = storageEstimate.usage;
      BASE_TELEMETRY_PROPERTIES.storageQuota = storageEstimate.quota;
    } catch (error) {
      log.warn("Failed to run estimate()", error, {
        file: "telemetry.ts",
        line: 23,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
    }
  }, 1e4);
}
var getTelemetryIdentifier = (client) => {
  if (!(client == null ? void 0 : client.initialized)) {
    return void 0;
  }
  const identity = client.halo.identity.get();
  if (identity) {
    humanize(identity.identityKey);
  }
  return void 0;
};
var isTelemetryDisabled = async (namespace) => {
  try {
    return await localForage.getItem(`${namespace}:telemetry-disabled`) === "true";
  } catch (err) {
    log.catch("Failed to check if telemetry disabled, assuming it is", err, {
      file: "telemetry.ts",
      line: 47,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
    return true;
  }
};
var storeTelemetryDisabled = async (namespace, value) => {
  try {
    await localForage.setItem(`${namespace}:telemetry-disabled`, value);
  } catch (err) {
    log.catch("Failed to store telemetry disabled", err, {
      file: "telemetry.ts",
      line: 56,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
  }
};
var getTelemetryGroup = async (namespace) => {
  try {
    return localForage.getItem(`${namespace}:telemetry-group`);
  } catch (err) {
    log.catch("Failed to get telemetry group", err, {
      file: "telemetry.ts",
      line: 64,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
  }
};
var initializeAppTelemetry = async ({ namespace, config, sentryOptions, telemetryOptions }) => {
  try {
    const group = await getTelemetryGroup(namespace);
    const release = `${namespace}@${config.get("runtime.app.build.version")}`;
    const environment = config.get("runtime.app.env.DX_ENVIRONMENT");
    BASE_TELEMETRY_PROPERTIES.group = group;
    BASE_TELEMETRY_PROPERTIES.release = release;
    BASE_TELEMETRY_PROPERTIES.environment = environment;
    const telemetryDisabled = await isTelemetryDisabled(namespace);
    const SENTRY_DESTINATION = config.get("runtime.app.env.DX_SENTRY_DESTINATION");
    log.info("sentry init", {
      SENTRY_DESTINATION,
      telemetryDisabled
    }, {
      file: "telemetry.ts",
      line: 94,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
    Sentry.init({
      enable: Boolean(SENTRY_DESTINATION) && !telemetryDisabled,
      destination: SENTRY_DESTINATION,
      environment,
      release,
      tracing: true,
      replay: true,
      // TODO(wittjosiah): Configure these.
      sampleRate: 1,
      replaySampleRate: 0.1,
      replaySampleRateOnError: 1,
      ...sentryOptions
    });
    Sentry.configureTracing();
    const TELEMETRY_API_KEY = config.get("runtime.app.env.DX_TELEMETRY_API_KEY");
    Telemetry.init({
      apiKey: TELEMETRY_API_KEY,
      enable: Boolean(TELEMETRY_API_KEY) && !telemetryDisabled,
      ...telemetryOptions
    });
    const IPDATA_API_KEY = config.get("runtime.app.env.DX_IPDATA_API_KEY");
    if (IPDATA_API_KEY) {
      await fetch(`https://api.ipdata.co?api-key=${IPDATA_API_KEY}`).then((res) => res.json()).then((data) => {
        BASE_TELEMETRY_PROPERTIES.city = data.city;
        BASE_TELEMETRY_PROPERTIES.region = data.region;
        BASE_TELEMETRY_PROPERTIES.country = data.country;
        BASE_TELEMETRY_PROPERTIES.latitude = data.latitude;
        BASE_TELEMETRY_PROPERTIES.longitude = data.longitude;
      }).catch((err) => Sentry.captureException(err));
    }
  } catch (err) {
    log.error("Failed to initialize app telemetry", err, {
      file: "telemetry.ts",
      line: 132,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
  }
};

// packages/apps/patterns/react-appkit/src/telemetry/listeners.ts
var lastFocusEvent = new Date();
var totalTime = 0;
var setupTelemetryListeners = (namespace, client) => {
  const clickCallback = (event2) => {
    if (BASE_TELEMETRY_PROPERTIES.group === "dxos" && event2.target && !event2.target.id) {
      console.warn("Click event on element without id:", event2.target);
    }
    setTimeout(() => {
      var _a2, _b;
      return Telemetry2.event({
        identityId: getTelemetryIdentifier(client),
        name: `${namespace}.window.click`,
        properties: {
          ...BASE_TELEMETRY_PROPERTIES,
          href: window.location.href,
          id: (_a2 = event2.target) == null ? void 0 : _a2.id,
          path: (_b = event2.path) == null ? void 0 : _b.filter((el) => Boolean(el.tagName)).map((el) => `${el.tagName.toLowerCase()}${el.id ? `#${el.id}` : ""}`).reverse().join(">")
        }
      });
    });
  };
  const focusCallback = () => {
    const now = new Date();
    setTimeout(() => Telemetry2.event({
      identityId: getTelemetryIdentifier(client),
      name: `${namespace}.window.focus`,
      properties: {
        ...BASE_TELEMETRY_PROPERTIES,
        href: window.location.href,
        timeAway: now.getTime() - lastFocusEvent.getTime()
      }
    }));
    lastFocusEvent = now;
  };
  const blurCallback = () => {
    const now = new Date();
    const timeSpent = now.getTime() - lastFocusEvent.getTime();
    setTimeout(() => Telemetry2.event({
      identityId: getTelemetryIdentifier(client),
      name: `${namespace}.window.blur`,
      properties: {
        ...BASE_TELEMETRY_PROPERTIES,
        href: window.location.href,
        timeSpent
      }
    }));
    lastFocusEvent = now;
    totalTime = totalTime + timeSpent;
  };
  const unloadCallback = () => {
    setTimeout(() => Telemetry2.event({
      identityId: getTelemetryIdentifier(client),
      name: `${namespace}.page.unload`,
      properties: {
        ...BASE_TELEMETRY_PROPERTIES,
        href: window.location.href,
        timeSpent: totalTime
      }
    }));
  };
  const errorCallback = (event2) => {
    setTimeout(() => Telemetry2.event({
      identityId: getTelemetryIdentifier(client),
      name: `${namespace}.window.error`,
      properties: {
        ...BASE_TELEMETRY_PROPERTIES,
        href: window.location.href,
        message: event2.message,
        filename: event2.filename,
        stack: event2.error.stack
      }
    }));
  };
  window.addEventListener("click", clickCallback, true);
  window.addEventListener("focus", focusCallback);
  window.addEventListener("blur", blurCallback);
  window.addEventListener("beforeunload", unloadCallback);
  window.addEventListener("error", errorCallback);
  return () => {
    window.removeEventListener("click", clickCallback, true);
    window.removeEventListener("focus", focusCallback);
    window.removeEventListener("blur", blurCallback);
    window.removeEventListener("beforeunload", unloadCallback);
    window.removeEventListener("error", errorCallback);
  };
};

export {
  __export,
  BASE_TELEMETRY_PROPERTIES,
  getTelemetryIdentifier,
  isTelemetryDisabled,
  storeTelemetryDisabled,
  getTelemetryGroup,
  initializeAppTelemetry,
  setupTelemetryListeners
};
//# sourceMappingURL=chunk-GBLFVQ25.mjs.map
